export default __webpack_public_path__ + "static/media/img-5.7b3da19b.jpg";